import { createAsyncThunk } from '@reduxjs/toolkit';

import { put } from 'api/requests';

export const putConfirmGaranteeLetter = createAsyncThunk(
  'EN_guaranteeLetter/putGaranteeLetter',
  async (id: number, thinkApi) => {
    try {
      const req = await put(`/api/standards/engineering_networks/${id}/guarantee-letter/complete/`);
      return req;
    } catch (error) {
      return thinkApi.rejectWithValue(error);
    }
  },
);
